import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {
  IconCellRenderer,
  LinkCellRenderer,
  confirm,
} from '@trueprodigy/components';
import AgGrid from '@components/AgGrid/AgGrid';
import BaseCheckBoxRenderer from './BaseCheckBoxRenderer';

import {
  Divider,
  HeaderContainer,
  Title,
  AddButton,
  TableContainer,
} from '@modules/appraisal/pages/propertyPage/components/tableStyledComponents';
import OwnerLookupModal from '@modules/appraisal/components/ownerLookupModal';

const OwnerGroup = ({
  addOwnerGroup,
  deleteOwnerGroup,
  ownerGroups,
  setPrimaryOwnerGroup,
  disabled,
}) => {
  const ownerGroupsData = ownerGroups.get('data').toJS();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);

  useEffect(() => {
    if (selectedOwner && selectedOwner[0]) {
      addOwnerGroup(selectedOwner[0].ownerId);
      setSelectedOwner(null);
    }
  }, [selectedOwner]);

  const getColumnDefs = () => {
    const columnDefs = [
      {
        headerName: 'Primary',
        field: 'isPrimaryOwner',
        cellRenderer: BaseCheckBoxRenderer,
        cellRendererParams: {
          disabled: disabled,
          onCheck: data => {
            setPrimaryOwnerGroup({ ownerID: data.ownerID });
          },
        },
      },
      {
        headerName: 'Owner ID',
        field: 'ownerID',
        cellRenderer: LinkCellRenderer,
        cellRendererParams: {
          onClick: (_, data) => {
            window.open(`/appraisal/ownerRecord/${data.ownerID}`, '_blank');
          },
        },
      },
      { headerName: 'Owner Name', field: 'name' },
      { headerName: 'Address', field: 'address' },
      {
        headerName: 'Actions',
        field: 'actions',
        maxWidth: 140,
        width: 140,
        cellRenderer: IconCellRenderer,
        cellRendererParams: {
          icons: [
            {
              icon: !disabled && 'fa-trash',
              onClick: (val, data) =>
                confirm('owner connection').then(() => {
                  deleteOwnerGroup(data.ownerID);
                }),
            },
          ],
        },
      },
    ];
    return columnDefs;
  };

  const onAdd = () => {
    setIsOpen(true);
  };

  return (
    <Container>
      <Divider />
      <HeaderContainer>
        <Title>Owner Group</Title>
        <AddButton size="small" disabled={disabled} onClick={onAdd}>
          Add
        </AddButton>
      </HeaderContainer>
      <TableContainer className="ag-theme-material">
        <AgGrid
          columnDefs={getColumnDefs()}
          disablePreferenceSave
          name="ownerGroups"
          rowData={ownerGroupsData}
        />
      </TableContainer>
      <OwnerLookupModal
        isIndependent
        isIndependentOpen={isOpen}
        independentClose={() => setIsOpen(false)}
        independentSubmit={data => setSelectedOwner(data)}
      />
    </Container>
  );
};

OwnerGroup.propTypes = {
  addOwnerGroup: PropTypes.func.isRequired,
  deleteOwnerGroup: PropTypes.func.isRequired,
  ownerGroups: ImmutablePropTypes.map,
  setPrimaryOwnerGroup: PropTypes.func.isRequired,
  disabled: PropTypes.any,
};

const Container = styled.div`
  background-color: #fff;
`;

export default OwnerGroup;
